
























import { computed, defineComponent, PropType, ref } from '@vue/composition-api';
import { ImaAppListItem } from '@tt4b/ttam-enums';

const name = 'ttam-instant-message-app-list';
export default defineComponent({
  name,
  props: {
    value: { type: Number },
    list: {
      type: Array as PropType<ImaAppListItem[]>,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const _imaType = computed({
      get: () => props.value,
      set: (val: number) => {
        emit('change', val);
        emit('input', val);
      },
    });
    const selectApp = computed(() => props.list.find(item => item.value === props.value));
    return {
      name,
      _imaType,
      selectApp,
    };
  },
});
